import React, { useState, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { LBFooter } from "components";
import {
  resetEmailCampaignPrepayment,
  resetEmailCampaignValuationSensitivity,
  getCampaignTypes,
  getEmailCampaign,
  updateEmailCampaign
} from "pages/campaigns/emailCampaign.store";
import { mapCompanySelector } from "store/state/auth";
import _ from "lodash";
import { ROUTE_CAMPAIGNS } from "constants/routes";

import DripCampaignModal from "../campaigns/components/DripCampaignModal";

import { getDealScreenerData, exportDealScreenerData } from "./DealScreener.store";
import NewEmail from "./Email/NewEmail";
import EmailTemplate from "./Email/EmailTemplate";

import { DealScreenerTable, FilterBar, FilterPanel } from "./";
import "./dealScreenerStyles.css";

const DealScreener = ({
  getDealScreenerData,
  exportDealScreenerData,
  resetEmailCampaignPrepayment,
  resetEmailCampaignValuationSensitivity,
  dealScreener,
  dealScreenerFiltered,
  brokerEmail,
  history,
  location,
  company,
  getCampaignTypes,
  getEmailCampaign,
  updateEmailCampaign,
  campaign,
  match
}) => {
  const { campaignId } = match.params;
  const [numberOfDealsMessage, setNumberOfDealsMessage] = useState("");
  const [noDealsMessage, setNoDealsMessage] = useState("");
  const [filterPanelIsOpen, setFilterPanelIsOpen] = useState(Boolean(campaignId));
  const [viewableDealScreenerData, setViewableDealScreenerData] = useState([]);
  const [clearFiltersFlag, setClearFiltersFlag] = useState(true);
  const [emailModalOpened, setEmailModalOpened] = useState(false);
  const [emailTemplateOpened, setEmailTemplateOpened] = useState(false);
  const [selectedDeal, setSelectedDeal] = useState({});
  const [visibleCampaign, setVisibleCampaign] = useState({});
  const [emailCampaignFilter, setEmailCampaignFilter] = useState({});
  const [continueButtonsAreDisabled, setContinueButtonsAreDisabled] = useState(true);
  const [initialDealScreenerLoad, setInitialDealScreenerLoad] = useState(true);

  const dealScreenerLength = dealScreener?.length;
  const dealScreenerFilteredLength = dealScreenerFiltered?.length;

  useEffect(() => {
    getDealScreenerData();
    getCampaignTypes();
    handleNumberOfDealsMessage(false);
  }, []);

  useEffect(() => {
    if (campaignId) {
      getEmailCampaign({ campaignId });
    }
  }, [campaignId]);

  useEffect(() => {
    if (campaign && campaignId) {
      setVisibleCampaign(campaign);
      // Set filter here as well for when we're loading for the edit
    }
  }, [campaign]);

  useEffect(() => {
    setViewableDealScreenerData(sortedDealScreenerAmounts(dealScreener));
    handleNumberOfDealsMessage(false);
    if (dealScreenerLength === 0) {
      setNoDealsMessage("No results returned based on the filters selected");
    }

    if (dealScreenerLength !== 0) {
      setInitialDealScreenerLoad(false);
    }
  }, [dealScreener]);

  useEffect(() => {
    if (dealScreenerFilteredLength === 0) {
      setViewableDealScreenerData(sortedDealScreenerAmounts(dealScreener));
      setNoDealsMessage("No results returned based on the filters selected");
    }
    setViewableDealScreenerData(sortedDealScreenerAmounts(dealScreenerFiltered));
    handleNumberOfDealsMessage(true);
  }, [dealScreenerFiltered]);

  useEffect(() => {
    setContinueButtonsAreDisabled(viewableDealScreenerData.length === 0);
  }, [viewableDealScreenerData]);

  useEffect(() => {
    handleNumberOfDealsMessage(false);
    setNoDealsMessage("");
  }, [clearFiltersFlag]);

  const singularOrPluralUnfiltered = num => (num === 1 ? "all deals" : `all ${num} deals`);
  const handleNumberOfDealsMessage = (isFiltered = false) => {
    if (!isFiltered || dealScreenerLength === dealScreenerFilteredLength && dealScreenerFilteredLength !== 0 && dealScreenerLength !== 0) {
      setNumberOfDealsMessage(`Showing ${singularOrPluralUnfiltered(dealScreenerLength)}`);
    }
    if (isFiltered && dealScreenerLength !== dealScreenerFilteredLength && dealScreenerFilteredLength !== 0) {
      setNumberOfDealsMessage(`Showing ${dealScreenerFilteredLength} out of ${dealScreenerLength === 1 ? "1 deal" : `${dealScreenerLength} deals`}`);
    }
    if (dealScreenerLength === 1 || dealScreenerFilteredLength === 1) {
      setNumberOfDealsMessage("Showing 1 deal");
    }
    if (isFiltered && dealScreenerFilteredLength === 0) {
      setNumberOfDealsMessage("");
    }
  };

  const handleNameClicked = dealId => history.push(`deal/${dealId}`, { from: location.pathname });
  const handleExportClicked = dsResult => exportDealScreenerData({ format: "EXCEL", results: dsResult });
  const handleOnClearFiltersClicked = () => {
    setNoDealsMessage("");
    setViewableDealScreenerData(sortedDealScreenerAmounts(dealScreener));
    setClearFiltersFlag(!clearFiltersFlag);
  };

  const sortedDealScreenerAmounts = deals => deals.sort((a, b) => b.currentDeal?.loanAmount - a.currentDeal?.loanAmount);

  const handleEmailClicked = dealId => {
    const deal = viewableDealScreenerData.find(({ id }) => id === dealId);
    setSelectedDeal(deal);
    setEmailModalOpened(true);
  };

  const closeEmailModal = () => setEmailModalOpened(false);

  const selectCampaignType = campaignType => {
    setSelectedDeal({ ...selectedDeal, campaignType });
    setEmailModalOpened(false);
    setEmailTemplateOpened(true);
  };

  const closeEmailTemplateModal = () => {
    resetEmailCampaignPrepayment();
    resetEmailCampaignValuationSensitivity();
    setEmailTemplateOpened(false);
  };

  const cancelDealSelection = () => history.push(ROUTE_CAMPAIGNS);

  const handleContinueCampaignClicked = () => {
    updateEmailCampaign({
      campaignId,
      newValues: { deals: viewableDealScreenerData },
      callback: () => {
        history.push(`/campaigns/${campaignId}`, { from: history.location.pathname });
      }
    });
  };

  return (
    <>
      <div className="deal-screener-root">
        <div>
          <FilterBar
            disabledContinueButtons={continueButtonsAreDisabled}
            disabledEditFilters={dealScreener?.length === 0 && dealScreenerFiltered?.length === 0}
            onClearFilters={handleOnClearFiltersClicked}
            numberOfDealsMessage={numberOfDealsMessage}
            onExport={() => {
              dealScreenerFiltered ? handleExportClicked(dealScreenerFiltered) : handleExportClicked(dealScreener);
            }}
            setFilterPanelIsOpen={setFilterPanelIsOpen}
            campaign={visibleCampaign}
            onContinueToCampaign={handleContinueCampaignClicked}
            cancelCampaign={cancelDealSelection}
          />
          {
            ((dealScreenerFilteredLength === 0 || dealScreenerLength === 0) && !initialDealScreenerLoad) ?
              <div className="deal-screener-number-of-deals-text-wrapper">{noDealsMessage}</div> :
              <DealScreenerTable
                isEmailCampaign={!_.isEmpty(visibleCampaign)}
                onNameClick={handleNameClicked}
                onEmailClick={handleEmailClicked}
                dealScreenerData={viewableDealScreenerData}
              />
          }
        </div>
        <div className="deal-screener-footer-wrapper">
          <LBFooter />
        </div>
      </div>
      <FilterPanel
        dealScreener={dealScreener}
        clearFiltersFlag={clearFiltersFlag}
        filterPanelIsOpen={filterPanelIsOpen}
        onClearFilters={handleOnClearFiltersClicked}
        onClose={() => setFilterPanelIsOpen(false)}
        setEmailCampaignFilter={setEmailCampaignFilter}
        isEmailCampaign={Boolean(visibleCampaign)}
      />

      {emailModalOpened && (
        <DripCampaignModal
          isOpen={emailModalOpened}
          maxWidth={false}
          title="Generate New Email"
          onClose={closeEmailModal}
          PaperProps={{ style: { width: "480px", height: "250px" } }}
        >
          <NewEmail
            onCancel={closeEmailModal}
            onCreate={selectCampaignType}
          />
        </DripCampaignModal>
      )}

      {emailTemplateOpened && (
        <DripCampaignModal
          isOpen={emailTemplateOpened}
          maxWidth={false}
          noPadding
          onClose={closeEmailTemplateModal}
          PaperProps={{ style: { width: "80vw", maxWidth: "996px" }}}
        >
          <EmailTemplate
            companyName={company?.name ?? "company"}
            companyLogo={company?.logoImage ?? ""}
            companyPrimaryColor={company?.primaryColor ?? "005AA9"}
            companySecondaryColor={company?.secondaryColor ?? "0F9AD6"}
            deal={selectedDeal}
            brokerEmail={brokerEmail}
            onCancel={closeEmailTemplateModal}
          />
        </DripCampaignModal>
      )}
    </>
  );
};

const mapStateToProps = ({
  dealScreenerReducer: { dealScreener, dealScreenerFiltered },
  authentication,
  emailCampaign: { campaign }
}) => ({
  dealScreener,
  dealScreenerFiltered,
  brokerEmail: authentication.user.contact.email,
  company: mapCompanySelector(authentication),
  campaign
});

export default compose(connect(
  mapStateToProps,
  {
    getDealScreenerData,
    exportDealScreenerData,
    resetEmailCampaignPrepayment,
    resetEmailCampaignValuationSensitivity,
    getCampaignTypes,
    getEmailCampaign,
    updateEmailCampaign
  }
))(DealScreener);
